/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { name, start_date, end_date, cover, description, event_type, will_process, twitter, website, instagram, facebook, address, city, state, lat, lon},
} = checkout;

const validations = Yup.object().shape({
    [name.name]: Yup.string().required(name.errorMsg),
    [start_date.name]: Yup.string().required(start_date.errorMsg),
    [end_date.name]: Yup.string().required(end_date.errorMsg),
    [description.name]: Yup.string().required(description.errorMsg),
    [event_type.name]: Yup.number().required(event_type.errorMsg),
    [will_process.name]: Yup.bool().required(will_process.errorMsg),
    [cover.name]: Yup.mixed().required('File is required'),
    [website.name]: Yup.string().matches(
      /((https?):\/\/)(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      'Enter correct url!'
    ).notRequired(),
    [twitter.name]: Yup.string().matches(
      /((https?):\/\/)(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      'Enter correct url!'
    ).notRequired(),
    [facebook.name]: Yup.string().matches(
      /((https?):\/\/)(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      'Enter correct url!'
    ).notRequired(),
    [instagram.name]: Yup.string().matches(
      /((https?):\/\/)(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      'Enter correct url!'
    ).notRequired(),
    [address.name]: Yup.string().required(address.errorMsg),
    [city.name]: Yup.string().required(city.errorMsg),
    [state.name]: Yup.string().required(state.errorMsg),
    [lat.name]: Yup.number().required(lat.errorMsg),
    [lon.name]: Yup.number().required(lon.errorMsg),
  });

export default validations;
